import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { UpgradePageRoutingModule } from './upgrade-routing.module';
import { UpgradePage } from './upgrade.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, UpgradePageRoutingModule, NgxTippyModule],
  declarations: [UpgradePage],
})
export class UpgradePageModule {}
